(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caratteristiche-business-s9001"]) return;
  try {
    
var swiperCaratteristiche = new Swiper('.caratteristiche-business', {
			slidesPerView: 2,
			spaceBetween: 20,
			centeredSlides: false,
			slidesPerGroup: 1,
			loop: true,
			breakpoints: {
				768: {
					slidesPerView: 6,
					slidesPerGroup: 6,
				},
        	}
		});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-eng"] && !Shopify.designMode) return;
  try {
    
var swiperCarousel = new Swiper('.home-carousel-container', {
  pagination: {
	el: '.swiper-pagination',
	clickable: true,
  },
  autoplay: {
    delay: 5000,
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-s9001"] && !Shopify.designMode) return;
  try {
    

var swiper = new Swiper('.carousel-s9001', {
     pagination: {
       el: '.pagination',
       type: 'fraction',
     },
     navigation: {
       nextEl: '.swiper-button-next',
       prevEl: '.swiper-button-prev',
     },
   });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carouselnew"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
  const swiperNewCarousel = new Swiper('.home-carouselnew-container', {
    // Your other Swiper options...
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      renderBullet: function (index, className) {
        const slideNumber = index + 1;
        return `
          <button class="${className}"
                  aria-label="Vai alla slide ${slideNumber}"
                  tabindex="0"
                  role="button">
            <span class="sr-only">${slideNumber}</span>
          </button>`;
      },
    },
  });

  // Simple function to maintain Italian labels
  function maintainItalianLabels() {
    document.querySelectorAll('.swiper-pagination-bullet').forEach((bullet, index) => {
      bullet.setAttribute('aria-label', `Vai alla slide ${index + 1}`);
    });
  }

  // Initialize labels
  maintainItalianLabels();
  
  // Update labels on slide change
  swiperNewCarousel.on('slideChange', function() {
    maintainItalianLabels();
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collezioni-section-hp-eng"] && !Shopify.designMode) return;
  try {
    
var swiperCollezioni = new Swiper('.system-carousel-container', {
  slidesPerView: 1,
  spaceBetween: 15,
  centeredSlides: false,
  slidesPerGroup: 1,
  loop: false,
  breakpoints: {
    768: {
      slidesPerView: 3,
      centeredSlides: false,
      slidesPerGroup: 3,
    },
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collezioni-section-hp"] && !Shopify.designMode) return;
  try {
    
var swiperCollezioni = new Swiper('.system-carousel-container', {
  slidesPerView: 1,
  spaceBetween: 15,
  centeredSlides: false,
  slidesPerGroup: 1,
  loop: false,
  breakpoints: {
    768: {
      slidesPerView: 3,
      centeredSlides: false,
      slidesPerGroup: 3,
    },
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section-abbonamenti-business"]) return;
  try {
    
  (function() {
    $('body').on('click', '.shopify_explorer_faq__question', function() {
      $(this).next('.shopify_explorer_faq__answer').slideToggle(150).toggleClass('active');
      $(this).toggleClass('active');
    });

    $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
      $(event.target).find('.shopify_explorer_faq__answer').slideDown(150);
    });

    $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
      $(event.target).find('.shopify_explorer_faq__answer').slideUp(150);
    });
  }());
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section-abbonamenti"]) return;
  try {
    
  (function() {
    $('body').on('click', '.shopify_explorer_faq__question', function() {
      $(this).next('.shopify_explorer_faq__answer').slideToggle(150).toggleClass('active');
      $(this).toggleClass('active');
    });

    $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
      $(event.target).find('.shopify_explorer_faq__answer').slideDown(150);
    });

    $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
      $(event.target).find('.shopify_explorer_faq__answer').slideUp(150);
    });
  }());
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section-promo-business"]) return;
  try {
    
  (function() {
    $('body').on('click', '.shopify_explorer_faq__question', function() {
      $(this).next('.shopify_explorer_faq__answer').slideToggle(150).toggleClass('active');
      $(this).toggleClass('active');
    });

    $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
      $(event.target).find('.shopify_explorer_faq__answer').slideDown(150);
    });

    $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
      $(event.target).find('.shopify_explorer_faq__answer').slideUp(150);
    });
  }());
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gamma-box-section-sp"] && !Shopify.designMode) return;
  try {
    
  var swiperGammaBox = new Swiper('.gamma-carousel-container', {
    slidesPerView: 1,
    spaceBetween: 30,
    centeredSlides: true,
    slidesPerGroup: 1,
    loop: true,
  });

		$( ".gamma-box-item" ).mouseover(function() {
			console.log("hover");
			$( this ).find( "a" ).show();
		});
		$( ".gamma-box-item" ).mouseout(function() {
			$( this ).find( "a" ).hide();
		});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["macchine-insights-sp"] && !Shopify.designMode) return;
  try {
    
console.log('swiper macchine');
var swiperMacchine = new Swiper('.machines-container', {
			slidesPerView: 1,
			centeredSlides: true,
			loop: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq-template"]) return;
  try {
    
  (function() {
    $('body').on('click', '.shopify_explorer_faq__question', function() {
      $(this).next('.shopify_explorer_faq__answer').slideToggle(150).toggleClass('active');
      $(this).toggleClass('active');
    });

    $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
      $(event.target).find('.shopify_explorer_faq__answer').slideDown(150);
    });

    $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
      $(event.target).find('.shopify_explorer_faq__answer').slideUp(150);
    });
  }());
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-macchine-business-template"]) return;
  try {
    
var swiperDettagli = new Swiper('.details-carousel-container', {
    slidesPerView: 1,
    spaceBetween: 30,
    centeredSlides: true,
    slidesPerGroup: 1,
    loop: false,
    breakpoints: {
      768: {
        spaceBetween: 10,
        slidesPerView: 3,
        centeredSlides: false,
        slidesPerGroup: 3,
      },
    }
  });

  var swiperCaratteristiche = new Swiper('.caratteristiche-business', {
    slidesPerView: 2,
    spaceBetween: 30,
    centeredSlides: true,
    slidesPerGroup: 1,
    loop: false,
    breakpoints: {
      768: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        centeredSlides: false,
      },
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-s9001"]) return;
  try {
    
var swiperProdReccom = new Swiper('.product-carousel-container', {
	slidesPerView: 1,
	spaceBetween: 45,
	centeredSlides: true,
	slidesPerGroup: 1,
	loop: true,
	breakpoints: {
		768: {
			slidesPerView: 4,
			centeredSlides: false,
			slidesPerGroup: 4,
		},
	},
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sintesi-s9001"]) return;
  try {
    
var swiperSintesi = new Swiper('.in-sintesi', {
	slidesPerView: 1,
	spaceBetween: 45,
	centeredSlides: true,
	slidesPerGroup: 1,
	loop: true,
	breakpoints: {
		768: {
			slidesPerView: 5,
			centeredSlides: false,
			slidesPerGroup: 5,
		},
	}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantaggi-section-abbonamenti-business"]) return;
  try {
    
var swiperSintesi = new Swiper('.in-sintesi', {
	slidesPerView: 1,
	spaceBetween: 45,
	centeredSlides: true,
	slidesPerGroup: 1,
	loop: true,
	breakpoints: {
		768: {
			slidesPerView: 5,
			centeredSlides: false,
			slidesPerGroup: 5,
		},
	}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantaggi-section-abbonamenti"]) return;
  try {
    
var swiperSintesi = new Swiper('.in-sintesi', {
	slidesPerView: 1,
	spaceBetween: 45,
	centeredSlides: true,
	slidesPerGroup: 1,
	loop: true,
	breakpoints: {
		768: {
			slidesPerView: 5,
			centeredSlides: false,
			slidesPerGroup: 5,
		},
	}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantaggi-section-abbonamenticapsule"]) return;
  try {
    
var swiperSintesi = new Swiper('.in-sintesi', {
	slidesPerView: 1,
	spaceBetween: 45,
	centeredSlides: true,
	slidesPerGroup: 1,
	loop: true,
	breakpoints: {
		768: {
			slidesPerView: 5,
			centeredSlides: false,
			slidesPerGroup: 5,
		},
	}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantaggi-section-promo-business"]) return;
  try {
    
var swiperSintesi = new Swiper('.in-sintesi', {
	slidesPerView: 1,
	spaceBetween: 45,
	centeredSlides: true,
	slidesPerGroup: 1,
	loop: true,
	breakpoints: {
		768: {
			slidesPerView: 5,
			centeredSlides: false,
			slidesPerGroup: 5,
		},
	}
});

  } catch(e) { console.error(e); }
})();
})();
